import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxReloadable } from "../../Lib/AxSystem/AxReloadable";

@ModuleName("LinkedArticleWaiver")
export class LinkedArticleWaiver implements AxInit, AxReloadable {    
    private localStorageIdentifier: string = "linkedArticleWaiver";
    private localStorageShopingCartPrefix: string = "cartId";
    private localStorageDocumentTypePrefix: string = "docType";

    getEnabledAndCheckedCheckboxes() {
        return $('.additionalArticleCheckB:checkbox:checked:enabled');
    }

    getLocalStorageShoppingCartFullName(shoppingCartId: string) {
        return `${this.localStorageShopingCartPrefix}_${shoppingCartId}`;
    }

    getLocalStorageDocumentTypeFullName(documentType: string) {
        return `${this.localStorageDocumentTypePrefix}_${documentType}`;
    }

    //Manage the visivility of each item.
    //Look for the additionalArticlesChecked, if empty hide linked-waiver-portlet, otherwise iterate over the waivers which have the article number on data-article-nrs attribute.    
    manageWaiverForCheckedAdditionalArticles() {
        let additionalArticlesChecked = [];
        this.getEnabledAndCheckedCheckboxes().each((index, element) => {
            const dataArticleNr = $(element).attr('data-ArticleNr');
            if (additionalArticlesChecked.indexOf(dataArticleNr) === -1 && dataArticleNr !== '') {
                additionalArticlesChecked.push(dataArticleNr)
            }
        });

        //Hide/Show waiver section
        if (additionalArticlesChecked.length == 0) {
            $('.linked-waiver-portlet').addClass('d-none');
        }
        else {
            $('.linked-waiver-portlet').removeClass('d-none');
            $('.linked-article-waiver-item').each((_index, element) => {
                //Hide by default all linked-article-waiver-item
                $(element).addClass('d-none');
                const articleNrList = $(element).attr('data-article-nrs').split(',');                
                articleNrList.forEach(articleNr => {                    
                    const existsArticle = additionalArticlesChecked.some((articleNumber) => articleNumber === articleNr);
                    if (existsArticle) {                    
                        //Show specifically linked-article-waiver-item
                        $(element).removeClass('d-none');
                    }
                });
            });
        }
    }

    // -----      KEY     ----- | ---------         VALUE         --------
    // localStorageIdentifier   | cartId_XX: [docType_XX, docType_XX, ...]
    retrieveLocalStorage(shoppingCartIdPrefix: string) {
        const currentLocalStorage = JSON.parse(localStorage.getItem(this.localStorageIdentifier) || '{}');
        //Delete if there are previous shopping cart in local storage.
        const previousShoppingCarts = Object.keys(currentLocalStorage).some(shopCartId => `${shopCartId}` !== shoppingCartIdPrefix);
        if (previousShoppingCarts) {
            localStorage.removeItem(this.localStorageIdentifier);
            return '{}';
        }
        return currentLocalStorage;
    }

    // Look for all linked articles waivers previously checked stored in local storage.
    checkLinkedArticlesWaiversFromLocalStorage() {
        $('.linkedArticleWaiver_checkBox').each((index, element) => {
            const shoppingCartIdWithPrefix = this.getLocalStorageShoppingCartFullName($(element).attr('data_ShoppingCartId'));
            const documentTypeIdWithPrefix = this.getLocalStorageDocumentTypeFullName($(element).attr('data_DocumentTypeId'));

            const currentLocalStorage = JSON.parse(localStorage.getItem(this.localStorageIdentifier) || '{}');
            let documentIds = currentLocalStorage[shoppingCartIdWithPrefix] || new Array();
            const existsDocumentId = documentIds.some(docId => docId === documentTypeIdWithPrefix);

            if (existsDocumentId) {
                $(element).prop('checked', true);
            }
        });
    }

    initialize(shoppingCartId: string) {
        this.eventListeners();
    }

    eventListeners() {
        // Get the click event of every linkedArticleWaiver_checkBox and save in local storage (persists in local storage every checkbox for the current shopping cart).
        $('.linkedArticleWaiver_checkBox').on('click', (event) => {
            const isChecked = $(event.target).is(':checked');
            const shoppingCartIdWithPrefix = this.getLocalStorageShoppingCartFullName($(event.target).attr('data_ShoppingCartId'));
            const documentTypeIdWithPrefix = this.getLocalStorageDocumentTypeFullName($(event.target).attr('data_DocumentTypeId'));

            let currentLocalStorage = this.retrieveLocalStorage(shoppingCartIdWithPrefix);
            let documentIds = currentLocalStorage[shoppingCartIdWithPrefix] || new Array();
            const existsSameDocumentId = documentIds.some(docId => docId === documentTypeIdWithPrefix);

            if (isChecked && !existsSameDocumentId) {
                documentIds.push(documentTypeIdWithPrefix);
            }
            if (!isChecked) {
                documentIds = documentIds.filter(docId => docId !== documentTypeIdWithPrefix);
            }

            if (documentIds.length > 0) {
                currentLocalStorage[shoppingCartIdWithPrefix] = documentIds;
                const localStorageEntry = JSON.stringify(currentLocalStorage);
                localStorage.setItem(this.localStorageIdentifier, localStorageEntry);
            } else {
                localStorage.removeItem(this.localStorageIdentifier);
            }
        });

        // Get the click event of every additionalArticleCheckB checkboxes in order to manage the visualization of linked-waiver-portlet and linked-article-waiver-item.
        $('.additionalArticleCheckB').off('change').on('change', (event) => {
            this.manageWaiverForCheckedAdditionalArticles();
        });
    }

    // Call when delete a position of the shopping cart.
    AxReload(shoppingCartId: string) {
        this.initialize(shoppingCartId);
    }

    // Call when ShoppingCart Index is loaded.
    AxInit(shoppingCartId: string) {
        // Delete existing (non-current shopping cart ids) saved in local storage.        
        this.retrieveLocalStorage(this.getLocalStorageShoppingCartFullName(shoppingCartId));
        this.initialize(shoppingCartId);
    }
}
